export const SITE_NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/gallery", label: "Gallery" },
  { to: "/certifications", label: "Certifications" },
  { to: "/blog", label: "Blog", hidden: true },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

/** Nav links shown in header/footer — set `hidden: true` on an item to hide temporarily */
export const VISIBLE_NAV_ITEMS = SITE_NAV_ITEMS.filter((item) => !item.hidden);
